import {ClinicsListResponse, ClinicsPlace, Nullable} from "../types";
import ClinicsMap from "../components/ClinicsMap";

type DataClinic = {
    address: string | null;
    id: number;
    image: string | null;
    latitude: string;
    longitude: string;
    name: string;
    phone: string | null;
    site: string | null;
    type: number | null;
}
export default class ClinicsPage {
    private $holder: JQuery;
    private readonly END_POINT: string = '';
    private readonly $list: JQuery;
    private readonly $map: JQuery;
    private readonly $select2: JQuery;
    private readonly $clinicCount: JQuery;
    private clinicsGeoItems: Nullable<ClinicsPlace>[] | null = null;
    private clinicsMap: ClinicsMap | null = null;
    private readonly $clinicListHolder: JQuery;

    private readonly selectors = {
        listHolder: '.js-clinics-list-holder',
        listClass: '.js-clinics-list',
        mapClass: '.js-map-holder',
        select2Class: '.js-select2',
        clinicCount: '.js-clinics-counter',
    };

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$list = this.$holder.find(this.selectors.listClass);
        this.$map = this.$holder.find(this.selectors.mapClass);
        this.$select2 = this.$holder.find(this.selectors.select2Class);
        this.$clinicCount = this.$holder.find(this.selectors.clinicCount);
        this.$clinicListHolder = this.$holder.find(this.selectors.listHolder);

        this.init();
    }

    private init(): void {
        const data = this.$clinicListHolder.data('map-items') as DataClinic[];
        this.clinicsMap = new ClinicsMap(
            this.$holder,
            data
        );
    }
}
